// extracted by mini-css-extract-plugin
export default {"advertCardHeader":"c-a_hu","advertCardHeader__actions":"c-a_hv","advertCardHeader__bottomLabel":"c-a_hw"};